/**
 * Admin saga functions
 */
import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import Actions from './actions';
import Constants from '../../constants';
import UserAPI from '../../Lib/Api/user';
import { handleError } from '../../Lib/Utils/saga-utils';
import VendorAPI from '../../Lib/Api/vendor.ts';

const { Vendor, User } = Constants;
const {
  fetchUsersSuccess,
  fetchUsersError,
  updateUserSuccess,
  updateUserError,
  fetchVendorsSuccess,
  fetchVendorsError,
} = Actions;

/**
 * Fetches users and dispatches success or error.
 *
 * @param {object} action action object containing type and payload properties
 */
export function* fetchUsers(action) {
  try {
    const response = yield call(UserAPI.get, action.params);
    yield put(fetchUsersSuccess(response));
  } catch (err) {
    yield handleError(fetchUsersError, err);
  }
}

/**
 * Fetches vendors and dispatches success or error.
 *
 * @param {object} action action object containing type and payload properties
 */
export function* fetchVendors(action) {
  try {
    const response = yield call(VendorAPI.getVendors, action.params);
    yield put(fetchVendorsSuccess(response));
  } catch (err) {
    yield handleError(fetchVendorsError, err);
  }
}

/**
 * Updates vendor password and dispatches success or error.
 *
 * @param {object} vendor action object containing vendor property
 */
export function* updateUser({ user }) {
  try {
    const response = yield call(UserAPI.update, user);
    yield put(updateUserSuccess(response));
  } catch (err) {
    yield handleError(updateUserError, err);
  }
}

/**
 * Allows multiple requests to fetch vendors to happen concurrently.
 * Gets the vendor response of the latest request fired to update vendor password.
 */
function* adminSaga() {
  yield all([
    yield takeLatest(Vendor.GET_VENDORS, fetchVendors),
    yield takeEvery(User.GET_USERS, fetchUsers),
    yield takeLatest(User.UPDATE_USER, updateUser),
  ]);
}

export default adminSaga;
